import React from 'react'
import Svg from '../../../Svg'

const EnvelopeHB = props => (
  <Svg width='66' viewBox='0 0 66 54' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M37.2231 38.6698L57.4582 23.2767C57.8305 22.9935 58.0455 22.5504 58.0373 22.0833C58.0292 21.6162 57.7988 21.1807 57.4169 20.9107L33.8875 4.27016C33.3784 3.90995 32.6968 3.90995 32.1875 4.27016L8.65815 20.9107C8.27619 21.1808 8.0459 21.6162 8.03776 22.0833C8.02962 22.5504 8.24462 22.9936 8.61688 23.2767L28.852 38.6698H37.2231Z'
      fill='#9D989B'
    />
    <path
      d='M56.5708 53.9999H9.512C8.69984 53.9999 8.04141 53.3423 8.04141 52.531V21.9782C8.04141 21.7519 7.56971 22.632 9.81028 24.165C13.348 26.8626 28.6782 38.5518 28.6782 38.5518H37.4046L57.5697 23.2216C57.9235 22.7499 58.0414 22.3962 58.0414 21.9782V52.531C58.0414 53.3423 57.383 53.9999 56.5708 53.9999Z'
      fill='#BBB2B7'
    />
    <path
      d='M8.51312 53.3894L28.8882 38.4929H37.1946L57.5697 53.3894C57.3045 53.7589 56.875 54 56.3888 54H9.69402C9.20781 54 8.77831 53.7588 8.51312 53.3894Z'
      fill='#B5ADB1'
    />
    <path
      d='M57.5692 53.3894L37.1941 38.4929L33.0409 38.4929V54H56.3883C56.8745 54 57.304 53.7589 57.5692 53.3894Z'
      fill='#C4BCC5'
    />
    <path
      d='M39.1038 39.1191C39.1038 42.5 36.3717 45.2382 33.0047 45.2382C29.6378 45.2382 26.9057 42.5 26.9057 39.1191C26.9057 35.7382 29.6378 33 33.0047 33C36.3717 33 39.1038 35.7382 39.1038 39.1191Z'
      fill='#37393B'
      stroke='#FC5AA6'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M34.3038 39.8513C33.8642 39.8513 33.5078 39.4942 33.5078 39.0537C33.5078 38.6129 33.8645 38.2558 34.3038 38.2558C34.7439 38.2558 35.1001 38.6129 35.1001 39.0537C35.1001 39.4942 34.7439 39.8513 34.3038 39.8513ZM31.7212 39.8513C31.2813 39.8513 30.9249 39.4942 30.9249 39.0537C30.9249 38.6129 31.2813 38.2558 31.7212 38.2558C32.161 38.2558 32.5174 38.6129 32.5174 39.0537C32.5174 39.4942 32.161 39.8513 31.7212 39.8513ZM30.9503 41.996H31.8211H34.199H35.063C35.3482 41.996 35.5801 41.7639 35.5801 41.4778V40.5991H35.8833C36.0374 40.5991 36.1622 40.4741 36.1622 40.3201V39.1918C36.1622 39.0376 36.0374 38.9128 35.8833 38.9128H35.5801V37.8063C35.5801 37.5205 35.3485 37.2884 35.063 37.2884H33.1502V36.9777C33.5395 36.9151 33.8373 36.5771 33.8373 36.1691C33.8373 35.7168 33.4713 35.3503 33.0199 35.3503C32.5685 35.3503 32.2027 35.7168 32.2027 36.1691C32.2027 36.5655 32.4835 36.8957 32.8569 36.9716V37.2884H30.95C30.6648 37.2884 30.4331 37.5202 30.4331 37.8063V38.9128H30.1258C29.9719 38.9128 29.8474 39.0378 29.8474 39.1918V40.3201C29.8474 40.4741 29.9721 40.5991 30.1258 40.5991H30.4334V41.4778C30.4334 41.7639 30.6648 41.996 30.9503 41.996ZM31.1166 40.9304C31.1166 40.7418 31.2696 40.5888 31.4583 40.5888H34.6392C34.8279 40.5888 34.9809 40.7418 34.9809 40.9304C34.9809 41.1191 34.8279 41.2721 34.6392 41.2721H31.4583C31.2696 41.2721 31.1166 41.1191 31.1166 40.9304Z'
      fill='white'
    />
  </Svg>
)

export default EnvelopeHB
